import Vue from "vue";
import Router from "vue-router";
import {translate} from '@/i18n/index.js'
// 首页
const Home = resolve => require(["views/Home.vue"], resolve);
// Create
const Create = resolve => require(["views/Create.vue"], resolve);
//404页面
const notfound = resolve => require(["views/404.vue"], resolve);
const download = resolve => require(["views/download.vue"], resolve)
// 福利
const welfare = resolve => require(["views/mainpage/welfare.vue"], resolve);
// 书库
const bookStack = resolve => require(["views/mainpage/bookStack.vue"], resolve);
/* 关于 */
// 用户注册协议
const userAgree = resolve => require(["views/about/userAgree.vue"], resolve);
const privacy = resolve => require(["views/about/privacy.vue"], resolve);
const logout = resolve => require(["views/about/logout.vue"], resolve);

// 作品管理
const authorIndex = resolve => require(["views/authorCenter/index"], resolve);
const authorIncome = resove => require(["views/authorIncome/index"], resove);
const messagecenter = resolve =>
    require(["views/messagecenter/index"], resolve);
const chapterList = resolve =>
    require(["views/authorCenter/secondLevel/chapterlist"], resolve);
const chapterManage = resolve =>
  require(["views/authorCenter/secondLevel/index"], resolve);
const applypublic = resolve =>
    require(["views/authorCenter/secondLevel/public"], resolve);
const contract = resolve =>
    require(["views/authorCenter/secondLevel/contract"], resolve);
const completing = resolve =>
    require(["views/authorCenter/secondLevel/completing"], resolve);
const reward = resolve =>
    require(["views/authorCenter/secondLevel/reward"], resolve);
const chapterincome = resolve =>
    require(["views/authorCenter/secondLevel/chapterincome"], resolve);
const chapterdel = resolve =>
    require(["views/authorCenter/secondLevel/chapterdel"], resolve);

const authorNewChapter = resolve =>
  require(["views/authorCenter/secondLevel/newChapter"], resolve);
/*推广详情页*/
const eDetail = resolve =>
    require(["views/extension/eDetail"], resolve);
const book1 = resolve =>
    require(["views/extension/book1"], resolve);
const noticebook = resolve =>
    require(["views/extension/noticebook"], resolve);
Vue.use(Router);
import { getToken } from "utils/storage";
const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/", // 首页
      name: "home",
      component: Home,
      meta: {
        keepAlive: true,
        title: "Black Gemstone - Fictional Stories Hub"
      }
    },
    {
      path: "/Create/:id", // 首页
      name: "Create",
      component: Create,
      meta: {
        keepAlive: false,
        title: "Black Gemstone - Create Novel Information"
      }
    },
    {
      path: "/welfare",
      name: "welfare",
      component: welfare,
      meta: {
        keepAlive: true,
        title: "Black Gemstone - Writer Benefits"
      }
    },
    {
      path: "/download", // 下载
      name: "Download APP",
      component: download,
      meta: {
        keepAlive: true,
        title: "Black Gemstone - Download APP"
      }
    },
    {
      path: "/author",
      name: translate('authorCenter.stories.title'),
      component: authorIndex,
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "Black Gemstone - Stories",
        icon: require('@/assets/author/Stroy-title-icon.png')
      },
    },
    {
      path: "/authorManage",
      name: translate('authorCenter.stories.title'),
      component: chapterManage,
      redirect: "/author",
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: translate('authorCenter.stories.title'),
        icon: require('@/assets/author/Stroy-title-icon.png')
      },
      children: [
        {
          path: "chapterList/:id",
          name: translate('authorCenter.stories.secondaryTitle[0]'),
          component: chapterList,
          islogin: true,
          meta: {
            title: translate('authorCenter.stories.secondaryTitle[0]'),
            isAuthor: true
          }
        },
        {
          path: "newChapter/:id/:chapterid/:allowPrice",
          name: translate('authorCenter.stories.newChapters'),
          component: authorNewChapter,
          islogin: true,
          meta: {
            title: translate('authorCenter.stories.newChapters'),
            isAuthor: true
          }
        },
       /* {
          path: "public/:id",
          name: "Submit for review",
          component: applypublic,
          islogin: true,
          meta: {
            keepAlive: false,
            title: "Apply for public",
            isAuthor: true
          }
        },*/
        {
          path: "contract/:id",
          name: translate('authorCenter.stories.secondaryTitle[1]'),
          islogin: true,
          component: contract,
          meta: {
            title: translate('authorCenter.stories.secondaryTitle[1]'),
            isAuthor: true
          }
        },
        {
          path: "completing/:id",
          name: translate('authorCenter.stories.secondaryTitle[2]'),
          component: completing,
          islogin: true,
          meta: {
            title: translate('authorCenter.stories.secondaryTitle[2]'),
            isAuthor: true
          }
        },
        {
          path: "reward/:id",
          name: translate('authorCenter.stories.secondaryTitle[3]'),
          component: reward,
          islogin: true,
          meta: {
            title: translate('authorCenter.stories.secondaryTitle[3]'),
            isAuthor: true
          }
        },
        {
          path: "chapterincome/:id",
          name: "Apply For Income",
          component: chapterincome,
          islogin: true,
          meta: {
            title: "Apply For Income",
            isAuthor: true
          }
        },
        {
          path: "chapterdel/:id",
          name: translate('authorCenter.stories.secondaryTitle[4]'),
          component: chapterdel,
          islogin: true,
          meta: {
            title: "Delete the story",
            isAuthor: true
          }
        },
      ]
    },
    {
      path: "/income",
      name: translate('authorCenter.income.title'),
      component: authorIncome,
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "Black Gemstone - Income",
        icon: require('@/assets/author/Income-title-icon.png')
      }
    },
    {
      path: "/info",
      name: translate('authorCenter.profile.title'),
      component: () => import('views/authorInfo/index'),
      meta: {
        // keepAlive: true,
        islogin: true,
        isAuthor: true,
        title: "Black Gemstone - Profile",
        icon: require('@/assets/author/info-title-icon.png')
      }
    },
    {
      path: "/message",
      name: translate('authorCenter.inbox.title'),
      component: messagecenter,
      meta: {
        // keepAlive: trSue,
        islogin: true,
        isAuthor: true,
        title: "Inbox",
        icon: require('@/assets/author/Comments-title-icon.png')
      },
    },
    {
      path: "*",
      name: "notfound",
      component: notfound,
      meta: {
        keepAlive: true,
        title: "页面不存在"
      }
    },
    {
      path: "/userAgree",
      name: "userAgree",
      component: userAgree,
      meta: {
        keepAlive: true,
        title: "User Services Agreement"
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        keepAlive: true,
        title: "User Agreement Privacy Policy"
      }
    },
    {
      path: "/logout",
      name: "logout",
      component: logout,
      meta: {
        keepAlive: true,
        title: "注销协议"
      }
    },
    {
      path: "/eDetail",
      name: "精彩内容",
      component: eDetail,
      meta: {
        title: "精彩内容",
        keepAlive: true,
      }
    },
    {
      path: "/book1",
      name: "Wonderful content",
      component: book1,
      meta: {
        title: "Wonderful content",
        keepAlive: true,
      }
    },
    {
      path: "/noticebook/:id",
      name: "Wonderful content",
      component: noticebook,
      meta: {
        title: "",
        keepAlive: false,
      }
    },
    {
      path: "/bookStack",
      name: "bookStack",
      component: bookStack,
      meta: {
        keepAlive: true,
        title: "书库-源石阅读"
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  window.scrollTo(0,0)
  if (to.meta.islogin && !getToken()) {
    //true则需要登录
    next({
      name: "home",
      query: {
        redirect: to.fullPath
      }
    });
    return;
  } else {
    // if (to.meta.isAuthor) {
    //   if (getwriter() != "true") {
    //     next({
    //       name: "applyWriter",
    //       query: {
    //         redirect: to.fullPath
    //       }
    //     });
    //   } else {
    //     next();
    //   }
    // } else {
    //   next();
    // }
    next();
  }
});
export default router;
